import React, { useState } from 'react'
import { Hexagon } from 'react-feather'

import ArrowIcon from '@material-ui/icons/ArrowForward'
import { Typography, Box, Button } from '@material-ui/core'

import {
  HexagonStructure,
  SolicitationContactModal,
  BaseDialog,
} from 'components'

import logo from 'images/dponet-logo-white.svg'
import styles from './styles'

import theme from 'theme'
import helpers from 'helpers'

import constants from 'constants/index'
import { makeStyles } from '@material-ui/styles'

const UpgradeModal = ({ open, onClose, setOpen }) => {
  const [openModal, setOpenModal] = useState(false)

  const useStyles = makeStyles(styles)
  const classes = useStyles()
  const { mixpanel } = helpers

  const handleOpenModal = () => {
    setOpenModal(true)
    mixpanel.track('Modal de upgrade para Dponet', 'Upgrade para a Dponet', {
      action: `upgrade_para_dponet-modal_de_upgrade`,
    })
  }

  const handleCloseModal = () => setOpenModal(false)

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      fullWidth
      closeButtonText="Fechar"
      noPadding
      noDialogTitle
    >
      <HexagonStructure
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        px={16}
        py={20}
        gap={16}
        width="100%"
        bgcolor={theme.palette.primary.main}
        position="relative"
      >
        <Box
          className={classes.transform}
          position="absolute"
          top="23%"
          left="50%"
          textAlign="center"
          color="primary"
          width="70%"
        >
          <Typography
            variant="h2"
            align="center"
            color="textSecondary"
            className={classes.typography}
          >
            Adequação completa e com banner de cookies ilimitado
          </Typography>
        </Box>
        <img src={logo} alt="Logo" width={160} />
      </HexagonStructure>
      <Box marginTop={theme.spacing(0.2)} marginLeft={theme.spacing(0.2)}>
        <Typography variant="h3" color="primary">
          Faça o upgrade para a DPOnet!
        </Typography>
      </Box>
      <Box marginTop={theme.spacing(0.2)} marginLeft={theme.spacing(0.2)}>
        <Typography variant="body1">
          Como fornecedor, você está utilizando uma versão básica para
          demonstrar sua conformidade com a LGPD. Aproveite todo o potencial da
          DPOnet e faça o upgrade para a versão completa da plataforma. Com ela,
          você alcança a conformidade real, com recursos avançados que garantem
          segurança, credibilidade e eficiência na gestão dos seus dados.
        </Typography>
      </Box>
      <Box
        gap={4}
        display="flex"
        flexDirection="column"
        marginTop={theme.spacing(0.2)}
        marginLeft={theme.spacing(0.2)}
      >
        {constants.plan.UPGRADE_BENEFITS_LIST.map((benefit, index) => (
          <Box
            gap={4}
            display="flex"
            key={index}
            marginTop={theme.spacing(0.1)}
          >
            <Hexagon size={20} color={benefit.iconColor} />
            <Box marginLeft={theme.spacing(0.15)}>
              <Typography variant="body1" fontWeight="bold">
                <strong>{benefit.name}</strong>
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
      <Box display="flex" width="100%" justifyContent="flex-end">
        <Button
          color="primary"
          variant="contained"
          endIcon={<ArrowIcon />}
          onClick={handleOpenModal}
        >
          Fale com um de nossos especialistas!
        </Button>
      </Box>
      <SolicitationContactModal
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </BaseDialog>
  )
}

export default UpgradeModal
